<template>
  <div>
    <div class="add-role-heading flex items-center justify-between pt-10">
      <h3>User Job Titles</h3>
      <vs-button
        @click="openAddEditPopup()"
        class="sm:w-auto sm:order-normal order-3 sm:mt-0 mt-4 add-line-button flex items-center justify-center mt-5"
        color="#00ccfe"
        type="filled"
      >
        <feather-icon icon="PlusIcon" svgClasses="h-6 w-6" />
        &nbsp; ADD NEW JOB TITLE
      </vs-button>
    </div>

    <div>
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="getDesignationList"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>

    <vs-popup
      class="holamundo add-new-user-role"
      title="Lorem ipsum dolor sit amet"
      :active.sync="IsAddEditPopupOpened"
      @close="IsAddEditPopupOpened = true"
    >
      <div class="user-popup">
        <vs-button
          @click="IsAddEditPopupOpened = false"
          radius
          color="#000"
          type="flat"
          icon-pack="feather"
          icon="icon-x"
          class="close"
        ></vs-button>
        <div class="add-role-heading flex items-center justify-center">
          <h3 v-if="designationName && designationId">Edit Job Title</h3>
          <h3 v-else>Add New Job Title</h3>
        </div>
        <div class="user-roles-add-form">
          <label>Job Title <span class="rqrd">*</span></label>
          <input
            type="text"
            name="designationName"
            value=""
            placeholder="Enter Job Title"
            v-model="designationName"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('designationName')"
            >The Job Title field is required</span
          >
        </div>
        <div class="flex justify-center align-center mt-8 pb-4">
          <vs-button
            @click="resetDesignation()"
            color="#d1d3d7"
            type="border"
            class="cancel-line-button mr-2"
            >CANCEL</vs-button
          >
          <vs-button
            :disabled="!validateForm"
            @click="before_save(false)"
            color="#00ccfe"
            type="filled"
            class="add-line-button"
            >Save</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>


<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
//store
import moduleCheckinRoleManagement from "@/store/checkin-role-management/moduleCheckinRoleManagementActions.js";
// import moduleDesignationManagement from "@/store/checkin-designation-management/moduleDesignationManagementActions.js";

import CellRendererDesignationActions from "./cell-renderer/CellRendererDesignationActions.vue";
import CellRendererDesignationStatus from "./cell-renderer/CellRendererDesignationStatus.vue";

import { bus } from "../../main";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
// Store Module

var self;
export default {
  components: {
    AgGridVue,
    CellRendererDesignationActions,
    CellRendererDesignationStatus,
  },

  data() {
    return {
      designationId: "",
      designationName: "",
      IsAddEditPopupOpened: false,
      gridApi: null,
      designationData: [],
      gridOptions: {},
      columnDefs: [
        {
          headerName: "Job Title",
          field: "Name",
          width: 400,
          filter: true,
          unSortIcon: true,
        },
        // {
        //   headerName: "Color Code",
        //   field: "Color",
        //   filter: true,
        //   unSortIcon: true,
        //   width: 350,
        // },
        // {
        //   headerName: "Access Type",
        //   field: "AccessType",
        //   filter: true,
        //   unSortIcon: true,
        //   width: 250,
        // },
        // {
        //   headerName: "Status",
        //   field: "IsPublished",
        //   filter: true,
        //   width: 150,
        //   cellRendererFramework: "CellRendererRoleStatus",
        //   cellRendererParams: (params) => {
        //     console.log("params===", params.data);
        //     return {
        //       data: params.data,
        //     };
        //   },
        // },
        {
          headerName: "Actions",
          filter: false,
          sortable: false,
          width: 150,
          cellRendererFramework: "CellRendererDesignationActions",
          cellRendererParams: (params) => {
            return {
              data: params.data,
            };
          },
          pinned: "right",
        },
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
    };
  },
  watch: {},
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    getDesignationList() {
      return this.designationData;
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    changeDesignationStatus(data) {
      // data.IsPublished = false;
      this.$vs.loading();
      debugger;
      this.$store
        .dispatch("checkinRoleManagement/updateDesignation", {
          id: data.DesignationId,
          data: data,
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Job Title",
              text: "Job Title updated successfully.",
            });
            this.fetchDesignations();
            this.IsAddEditPopupOpened = false;
            this.$emit("saveDesignationSuccess");
            // this.$emit("saveLocationSuccess", 1);
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "success",
              text: "Job Title not updated successfully.",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            title: "Job Title",
            text: "Something went wrong!",
          });
        });
    },
    resetDesignation() {
      this.designationName = "";
      this.IsAddEditPopupOpened = false;
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.createDesignation();
        }
      });
    },
    createDesignation() {
      if (!this.validateForm) return;
      this.$vs.loading();
      var data_local = {};
      debugger;

      if (this.designationId) {
        data_local = {
          DesignationId: this.designationId,
          Name: this.designationName,
          IsPublished: true,
        };
      } else {
        data_local = {
          Name: this.designationName,
          IsPublished: true,
        };
      }

      if (this.designationId) {
        this.$store
          .dispatch("checkinRoleManagement/addDesignation", {
            data: data_local,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Job Title",
                text: "Job Title updated successfully.",
              });
              this.fetchDesignations();
              this.IsAddEditPopupOpened = false;
            } else if (res.status == 99) {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "success",
                text: res.msg,
              });
              this.IsAddEditPopupOpened = false;
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "success",
                text: "Job Title not updated successfully.",
              });
              this.IsAddEditPopupOpened = false;
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Job Title",
              text: "Something went wrong!",
            });
            this.IsAddEditPopupOpened = false;
          });
      } else {
        console.log("2");
        this.$store
          .dispatch("checkinRoleManagement/addDesignation", {
            data: data_local,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Job Title",
                text: "Job Title created successfully.",
              });
              this.fetchDesignations();
              this.$emit("saveDesignationSuccess");
              this.IsAddEditPopupOpened = false;
            } else if (res.status == 500) {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Job Title",
                text: res.message,
              });
              this.IsAddEditPopupOpened = false;
            } else {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Job Title",
                text: res.message,
              });
              this.IsAddEditPopupOpened = false;
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Job Title",
              text: "Something went wrong!",
            });
            this.IsAddEditPopupOpened = false;
          });
      }
    },
    fetchDesignations() {
      self.$vs.loading();
      self.$store
        .dispatch("checkinRoleManagement/fetchDesignations")
        .then((res) => {
          console.log("res===111==", res);
          if ((res.status = 200)) {
            //this.designationData = res.data[0];
            self.designationData = [];

            if (res.data && res.data.length > 0) {
              res.data[0].map(function (item) {
                if (item.IsPublished) {
                  console.log("item==", item.Name);

                  self.designationData.push(item);
                }
              });
            }

            if (self.designationData && self.designationData.length > 0) {
              this.designationData.sort((a, b) => {
                console.log("a====", a.CreatedDate["_seconds"]);

                const aDate = new Date(a.CreatedDate["_seconds"] * 1000);
                const bDate = new Date(b.CreatedDate["_seconds"] * 1000);
                return bDate.getTime() - aDate.getTime();
              });
            }
          }
          this.pageLoaded = true;
          this.$vs.loading.close();
        })
        .catch((err) => {
          debugger;
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            title: "Job Title",
            text: "Something went wrong!",
          });
        });
    },
    openAddEditPopup() {
      this.designationName = "";
      this.IsAddEditPopupOpened = true;
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  destroyed() {
    bus.$off("editDesignation");
    bus.$off("changeDesignationStatus");
  },
  created() {
    self = this;
    if (!moduleCheckinRoleManagement.isRegistered) {
      self.$store.registerModule(
        "checkinRoleManagement",
        moduleCheckinRoleManagement
      );
      moduleCheckinRoleManagement.isRegistered = true;
    }
    self.fetchDesignations();
    bus.$on("editDesignation", async (designation) => {
      this.designationName = designation.Name;
      this.designationId = designation.DesignationId;

      this.IsAddEditPopupOpened = true;
    });

    bus.$on("changeDesignationStatus", async (designation) => {
      this.changeDesignationStatus(designation);
    });
  },
};
</script>